module.exports = __webpack_public_path__ + "img/Training.74c08094.svg";